module.exports = __webpack_public_path__ + "img/t_searchdemo.6f479f51.gif";